export const NO_TRANSFER_BATCH = "No transfers to sync";
export const NO_TRANSFER_SUBTITLE =
  "There are no transfers for you to sync at the moment. If you are expecting to see some transfers here, please doublecheck that they have been recorded in Investran and then reach out to support. ";
export const NO_TRANSFER_HISTORY = "No transfers history";
